module.exports = __webpack_public_path__ + "static/media/BalancoFinanc6.cda5f9e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelBalancoFinanc/BalancoFinanc6.png
// module id = 2175
// module chunks = 0